var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configuration-widget text"},[_vm._v("\n  "+_vm._s(_vm.definition.label)+"\n  "),(_vm.definition.type == 'MetabaseWidget')?_c('MetabaseCard',{attrs:{"definition":_vm.definition}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }